<template>
<div id='mytable' class='content'>

    <div class="table-responsive" :style="{tableLayout:'inherit'}">
        <div v-if="!nosearch">Search:

            <input size="sm" v-model="filter" style="border: unset;" />
            <p />
        </div>
        <table class="table table-striped">
            <thead class="" style="cursor: pointer">
                <tr>
                    <th v-for="(head) in Object.keys(this.filteredDatalist[0])" @click="sortBy(head)" :key='head' :style="{whiteSpace: 'nowrap'}">{{ head }}
                        <span v-if='sortOrders[head]==1 && sortKey == head'><img src='./up.png' width=10 height=10 /></span>
                        <span v-else-if='sortKey == head'><img src='./down.png' width=10 height=10 /></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(element,index) in this.filteredDatalist" :key='index+element'>
                    <td :style="[{whiteSpace: 'nowrap'}, !isNaN(data) ? {textAlign:'right'} : {}]" v-for="(data,k) in element">
                        <div v-if="k=='link'">
                            <router-link :to="data.url">{{data.text}}</router-link>
                            <!-- <a :href='data.url' :target='data.target'>{{data.text}}</a> -->
                        </div>
                        <div v-else>
                            <div v-if="k.startsWith('action')">
                                <button v-on:click="$emit(data.toLowerCase()+'-item', element)">{{data}}</button>
                            </div>
                            <div v-else>
                                <div v-if="data.name">
                                    {{ maskNumber(data.name) }}
                                </div>
                                <div v-else>
                                    {{ maskNumber(data) }}
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
const formatSimple = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    // currency: '',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
})

export default {
    name: 'enhanced-table',
    props: {
        datalist: Array,
        columns: Array,
        nosearch: false,
        hideFields: Array,
    },
    created: function () {
        this.filteredList()
    },
    data: function () {
        return {
            filter: '',
            currentOrder: 1,
            sortKey: '',
            sortOrders: {},
            sortHash: 1,
            hideFields: [],
            filteredDatalist: [],
        }
    },
    watch: {
        filter: function () {
            this.filteredList()
        },
        datalist: function () {
            this.filter = ''
            this.filteredList()
        },
    },
    computed: {},
    filters: {
        capitalize: function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
    },
    methods: {
        filteredList: function () {
            var vm = this
            var datalist = Object.assign([], this.datalist)
            var sortOrders = this.sortOrders
            if (this.filter !== '') {
                datalist = datalist.filter((element) => {
                    for (let prop in element) {
                        if (typeof (element[prop]) != 'object' && element[prop].toLowerCase().includes(this.filter.toLowerCase())) {
                            return element
                        }
                    }
                });
            }
            if (vm.sortKey !== '' && datalist.length > 0) {
                datalist = datalist.slice().sort(function (a, b) {
                    a = isNaN(a[vm.sortKey]) ? a[vm.sortKey] : Number(a[vm.sortKey])
                    b = b[vm.sortKey]
                    return (a === b ? 0 : a > b ? 1 : -1) * sortOrders[vm.sortKey]
                })
            }
            if (datalist.length > 0) {
                this.filteredDatalist = Object.assign([], datalist)
            }
            this.hideFieldsOnDatalist()
        },

        hideFieldsOnDatalist: function () {
            // remove hidden fields from the datalist
            var newDatalist = []
            var vm = this
            this.filteredDatalist.forEach(function (v) {
                var record = {}
                Object.keys(v).forEach(function (k) {
                    if (!vm.hideFields.includes(k)) {
                        record[k] = v[k]

                    }
                })
                newDatalist.push(record)
            })
            this.filteredDatalist = JSON.parse(JSON.stringify(newDatalist))

        },
        maskNumber: function (value) {
            if (isNaN(value)) {
                return value
            } else {
                return formatSimple.format(value)
            }
        },
        sortBy: function (key) {
            this.sortKey = key
            if (isNaN(this.sortOrders[key]))
                this.sortOrders[key] = -1
            this.sortOrders[key] = this.sortOrders[key] * -1
            this.filteredList()
        },
    }
}
</script>

<style scoped>
table,
td {
    max-width: 600px;
    overflow: hidden;
    text-overflow: clip;
}
</style>
